import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import styled from 'styled-components';

import { ExitIcon } from 'ui/components/Icons';

interface GeneralDialogProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const StyledDialog = styled.dialog(
  ({ theme }) => `
  background-color: ${theme.colors.grayDarkest};
  border-radius: 12px;
  border: none;
  padding: 15px;
  text-align: center;
  min-width: 337px;
  max-width: 500px;
  width: 90%;
  min-height: 300px;
  padding-top: 30px;

  &::backdrop {
    background-color: rgb(0 0 0 / 50%);
  }
`,
);

const CloseButton = styled.button(
  ({ theme }) => `
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${theme.colors.focusOutline};
  }
`,
);

export function GeneralDialog({ children, isOpen, onClose }: GeneralDialogProps) {
  const ref = useRef<HTMLDialogElement>(null);
  const intl = useIntl();

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (isOpen && !dialog.open) dialog.showModal();
    if (!isOpen && dialog.open) dialog.close();
  }, [isOpen]);

  return (
    <StyledDialog ref={ref} onClose={onClose}>
      <CloseButton
        type="button"
        onClick={onClose}
        aria-label={intl.formatMessage({ id: 'membership-modal-close-button' })}
      >
        <ExitIcon aria-hidden="true" focusable="false" />
      </CloseButton>
      {children}
    </StyledDialog>
  );
}
